export enum SubscriptionCreationEnum {
  DEMO,
  NEW,
}
